<script>
    import Menuicon from "../components/Menuicon.svelte";
    import Logo from "../components/Logo.svelte";

    import { Routes } from "../stores.js";

    const handleGnbClick = {
        nav: e => {
            let check = document.getElementById('gnb-btn-check');
            if (check.checked) check.checked = false;
        },
        gnb: e => {
            let target = e.target;
            let parent = target.parentElement;
            let check = document.getElementById('gnb-btn-check');
            if (check.checked) {
                if (parent.classList.contains('layout-header__gnb-item_has-lnb')) e.preventDefault();
                parent.classList.add('layout-header__gnb-item_active');
                document.querySelectorAll('.layout-header__gnb-item_active').forEach(ele => {
                    if (ele !== parent) ele.classList.remove('layout-header__gnb-item_active');
                });
            }
        }
    }
</script>

<header class="layout__header layout-header">
    <div class="layout__inner layout-header__inner">
        <input type="checkbox" id="gnb-btn-check" class="layout-header__gnb-btn-check">
        <h1 class="layout-header__logo"><a class="layout-header__logo-anchor" href="#/home"><Logo class="layout-header__logo-img" />COFFEE MENTORS</a></h1>
        <label for="gnb-btn-check" class="layout-header__gnb-btn gnb-btn">
            <div class="gnb-btn__bars">
                <span class="gnb-btn__bar"></span>
                <span class="gnb-btn__bar"></span>
                <span class="gnb-btn__bar"></span>
                <span class="gnb-btn__bar"></span>
                <span class="gnb-btn__bar"></span>
                <span class="gnb-btn__bar"></span>
            </div>
        </label>
        <nav class="layout-header__gnb" on:click|self="{handleGnbClick.nav}">
            <ul class="layout-header__gnb-list">
            {#each $Routes as route}
                {#if route.hidden !== true }
                <li class="layout-header__gnb-item {route.class ? route.class.join(' ') : ''}">
                    <a class="layout-header__gnb-anchor" href="#{route.href}" on:click="{handleGnbClick.gnb}">{route.name}</a>
                    {#if typeof(route.child) !== 'undefined' }
                    <ul class="layout-header__lnb-list">
                        {#each route.child as child}
                        <li class="layout-header__lnb-item {child.class ? child.class.join(' ') : ''}"><a class="layout-header__lnb-anchor" href="#{child.href}"><Menuicon class="layout-header__lnb-icon" /> {child.name}</a></li>
                        {/each}
                    </ul>
                    {/if}
                </li>
                {/if}
            {/each}
            </ul>
        </nav>
    </div>
</header>
